export default __webpack_public_path__ + "static/media/Icon.1002b3e0.svg";